module.exports = __webpack_public_path__ + "html/card-ghost.template.html";